// Person-shaped attributes (contacts, users) render as "First Last", tolerant
// of partially-filled names. Returns '' when nothing is present so callers can
// `|| fallback` cleanly.
export function fullName(
  attrs: { first_name?: string | null; last_name?: string | null } | null | undefined,
): string {
  if (!attrs) return ''
  return `${attrs.first_name ?? ''} ${attrs.last_name ?? ''}`.trim()
}

// The inverse, for quick-capture: the dispatcher types one name into the contact
// combobox and « + Créer "X" » must land it in the two fields the API requires.
// Split on the LAST space — « Marie-Claude Saint-Pierre Tremblay » is far more
// often a two-word surname than a two-word given name, and either way both
// fields stay editable, so this is a prefill and never a parse to be trusted.
// A lone word fills the first name only: the dispatcher heard « Ginette » and
// the surname is the thing still missing.
export function splitFullName(input: string): { firstName: string; lastName: string } {
  const name = input.trim().replace(/\s+/g, ' ')
  const cut = name.lastIndexOf(' ')
  if (cut === -1) return { firstName: name, lastName: '' }
  return { firstName: name.slice(0, cut), lastName: name.slice(cut + 1) }
}
